export default __webpack_public_path__ + "static/media/one-mini.4ef6980e.jpg";